// src/components/VendorDashboard.js
import React from 'react';
import StatCard from './StatCard';
import PendingAppointments from './PendingAppointments';
import ActiveDealsPerformance from './ActiveDealsPerformance';

const VendorDashboard = () => {
  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-gray-800">Vendor Dashboard</h1>
        <button className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 rounded-md flex items-center">
          <svg
            className="w-5 h-5 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
            ></path>
          </svg>
          Create New Deal
        </button>
      </div>

      {/* Stat Cards Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <StatCard
          title="Total Sales"
          value="₹45,289"
          change="+12.5%"
          period="vs last month"
          icon="📈" // Placeholder for an actual icon
          iconBgColor="bg-green-100"
          iconTextColor="text-green-600"
          arrowColor="text-green-500"
          isPositive={true}
        />
        <StatCard
          title="Active Deals"
          value="8"
          change="+3 new this week"
          icon="🏷️" // Placeholder for an actual icon
          iconBgColor="bg-orange-100"
          iconTextColor="text-orange-600"
          arrowColor="text-green-500" // New deals are positive
          isPositive={true}
        />
        <StatCard
          title="Appointments"
          value="24"
          change="-2 vs last week"
          icon="📅" // Placeholder for an actual icon
          iconBgColor="bg-blue-100"
          iconTextColor="text-blue-600"
          arrowColor="text-red-500"
          isPositive={false}
        />
        <StatCard
          title="Revenue"
          value="₹12,458"
          change="+0.2% vs last month"
          icon="💲" // Placeholder for an actual icon
          iconBgColor="bg-purple-100"
          iconTextColor="text-purple-600"
          arrowColor="text-green-500"
          isPositive={true}
        />
      </div>

      {/* Bottom Sections */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <PendingAppointments />
        <ActiveDealsPerformance />
      </div>
    </div>
  );
};

export default VendorDashboard;